import { useParams } from 'react-router-dom';

// Components
import SideBarContainer from 'Containers/SideBarContainer';
import { CircularProgress, IconButton, Typography } from '@mui/material';
import CoursesLessonsHeader from 'Pages/courses/Components/CoursesLessonsHeader/CoursesLessonsHeader';
import CoursesLessonsFilters from 'Pages/courses/Components/CoursesLessonsFilters/CoursesLessonsFilters';
import CoursesLessonsPaginatedTable from 'Pages/courses/Components/CoursesLessonsPaginatedTable/CoursesLessonsPaginatedTable';
import CoursesLessonsConfirmationModal from 'Pages/courses/Components/CoursesLessonsConfirmationModal/CoursesLessonsConfirmationModal';

// Others
import useCoursesLessonsPage from 'Hooks/useCoursesLessonsPage';
import { colors } from 'Constants/Colors';
import { ArrowBack } from '@mui/icons-material';
import { CoursesLessonsBackdrop, CoursesLessonsContainer } from './courses-lessons.styled';

interface Params {
  courseId: string;
  lessonId: string;
}

export default function CoursesLessons() {
  // Parametros de la ruta
  const { courseId, lessonId } = useParams<Params>();

  // Custom Hook para manejar el estado de la página
  const {
    lesson,
    loading,
    onReset,
    disabled,
    onSubmit,
    onSearch,
    saveModal,
    editValues,
    employees,
    publishAll,
    openSaveModal,
    onFieldChange,
    closeSaveModal,
    onPublishChange,
    getEmployeeValue,
    loadingEmployees,
    deactivateDisabled,
  } = useCoursesLessonsPage(courseId, lessonId);

  return (
    <SideBarContainer>
      <CoursesLessonsContainer>
        <IconButton onClick={() => history.back()} sx={{ width: '40px', height: '40px' }}>
          <ArrowBack />
        </IconButton>
        <CoursesLessonsHeader
          title={lesson?.name}
          evaluationType="Evaluación"
          onClickEdit={deactivateDisabled}
          disabled={disabled}
          onClickCancel={() => {
            onReset();
            closeSaveModal();
          }}
          onClickSave={openSaveModal}
        />
        <CoursesLessonsFilters onSearch={onSearch} />
        <CoursesLessonsPaginatedTable
          employees={employees}
          handleFieldChange={onFieldChange}
          onPublishChange={onPublishChange}
          loading={loadingEmployees}
          getEmployeeValue={getEmployeeValue}
          editValues={editValues}
          disabled={disabled}
          publishAll={publishAll}
        />
        <CoursesLessonsConfirmationModal saveModal={saveModal} closeSaveModal={closeSaveModal} onSubmit={onSubmit} />
        <CoursesLessonsBackdrop open={loading}>
          <CircularProgress sx={{ color: colors.WHITE }} />
          <Typography sx={{ color: colors.WHITE, fontSize: '18px' }}>Aplicando los cambios...</Typography>
        </CoursesLessonsBackdrop>
      </CoursesLessonsContainer>
    </SideBarContainer>
  );
}
